<template>
<div>
    <div class="upload"></div>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
</div>
</template>

<script>
import message from '../Message/Message.vue'
    export default {
        name: 'upload-btn',
        components:{message},
        props: {
            accept: {
                type: Object,
                default: null,
            },
            // 上传地址
            url: {
                type: String,
                // default: 'http://192.168.0.52:28080/axt-resources/upload/chunkUpload',
                // default: 'http://192.168.0.25/axt-resources/upload/chunkUpload',
                // default: process.env.url_api + '/axt-resources/upload/chunkUpload',
                default: process.env.url_api +'/axt-resources/upload/chunkUpload',
                //default: '/axt-resources/upload/chunkUpload'
            },
            // 上传最大数量 默认为100
            fileNumLimit: {
                type: Number,
                default: 100,
            },
            // 大小限制 默认2M
            fileSingleSizeLimit: {
                type: Number,
                default: 204800,
            },
            // 生成formData中文件的key，下面只是个例子，具体哪种形式和后端商议
            keyGenerator: {
                type: Function,
                default(file) {
                    const currentTime = new Date().getTime();
                    const key = `${currentTime}.${file.name}`;
                    return key;
                },
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            // 上传按钮ID
            uploadButton: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                uploader: null,
                isShowMessage:false,
                msg:null,

            };
        },
        mounted() {
            this.initWebUpload();
        },
        methods: {
            initWebUpload() {
                const that = this;
                this.uploader = WebUploader.create({
                    auto: true, // 选完文件后，是否自动上传
                    swf: '/static/lib/webuploader/Uploader.swf',  // swf文件路径
                    server: this.url,  // 文件接收服务端
                    pick: {
                        id: this.uploadButton,     // 选择文件的按钮
                        multiple: this.multiple,   // 是否多文件上传 默认false
                        label: '',
                    },
                    accept: this.getAccept(this.accept),  // 允许选择文件格式。
                    threads: 1,
                    fileNumLimit: this.fileNumLimit, // 限制上传个数
                    //fileSingleSizeLimit: this.fileSingleSizeLimit, // 限制单个上传图片的大小
                    formData: {
                      taskId: this.getUUID(),
                      sizeSimple: 5242880,
                      businessType: 3
                    },  // 上传所需参数
                    chunked: true,          //分片上传
                    chunkSize: 20480000,  //分片大小
                    duplicate: true,  // 重复上传
                });
                this.uploader.on('beforeFileQueued',(file)=>{
                    if(file.size > 204800000){
                        that.msg = '上传文件不能大于 200 MB'
                        that.isShowMessage = true;
                        return false;
                    }
                })
                // 当有文件被添加进队列的时候，添加到页面预览
                this.uploader.on('fileQueued', (file) => {
                    this.$emit('fileChange', file);
                });
                this.uploader.on('uploadStart', (file) => {
                    // 在这里可以准备好formData的数据

                    //this.uploader.options.formData.key = this.keyGenerator(file);
                });
                // 文件上传过程中创建进度条实时显示。
                this.uploader.on('uploadProgress', (file, percentage) => {
                    this.$emit('progress', file, percentage);
                });
                this.uploader.on('uploadSuccess', (file, response) => {
                    this.$emit('success', file, response);
                });
                this.uploader.on('uploadError', (file, reason) => {
                    this.$emit('uploadError', file, reason);
                });
                //当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次。
                // this.uploader.on('uploadBeforeSend',(obj, data, headers) => {
                // 	//data.uuid = $("#uuid").val(); //更新uuid
                // });
                this.uploader.on('error', (type) => {
                    let errorMessage = '';
                    if (type === 'F_EXCEED_SIZE') {
                        errorMessage = `文件大小不能超过${this.fileSingleSizeLimit / (1024 * 1000)}M`;
                    } else if (type === 'Q_EXCEED_NUM_LIMIT') {
                        errorMessage = '文件上传已达到最大上限数';
                    } else {
                        errorMessage = `上传出错！请检查后重新上传！错误代码${type}`;
                    }
                    this.$emit('error', errorMessage);
                });
                this.uploader.on('uploadComplete', (file, response) => {
                    this.$emit('complete', file, response);
                });
            },
            upload(file) {
                this.uploader.upload(file);
            },
            stop(file) {
                this.uploader.stop(file);
            },
            // 取消并中断文件上传
            cancelFile(file) {
                this.uploader.cancelFile(file);
            },
            // 在队列中移除文件
            removeFile(file, bool) {
                this.uploader.removeFile(file, bool);
            },
            getUUID() {
            	var s = [];
            	var hexDigits = "0123456789abcdef";
            	for (var i = 0; i < 36; i++) {
            		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            	}
            	s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            	s[8] = s[13] = s[18] = s[23] = "-";

            	var uuid = s.join("");
                localStorage.setItem('uuid',uuid)
            	return uuid;
            },
            getAccept(accept) {
                switch (accept) {
                    case 'text':
                        return {
                            title: 'Texts',
                            exteensions: 'doc,docx,xls,xlsx,ppt,pptx,pdf,txt',
                            mimeTypes: '.doc,docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt'
                        };
                        break;
                    case 'video':
                        return {
                            title: 'Videos',
                            exteensions: 'mp4',
                            mimeTypes: '.mp4'
                        };
                        break;
                    case 'image':
                        return {
                            title: 'Images',
                            exteensions: 'gif,jpg,jpeg,bmp,png',
                            mimeTypes: '.gif,.jpg,.jpeg,.bmp,.png'
                        };
                        break;
                    default: return accept
                }
            },
            isShowMsg(msg){
                this.isShowMessage = false;
            }
        },
    };
</script>

<style lang="">
    .webuploader-container {
        position: relative;
    }
    .webuploader-element-invisible {
        position: absolute !important;
        clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
        clip: rect(1px,1px,1px,1px);
    }
    .webuploader-pick {
      width: 110px;
      height: 45px;
      line-height: 45px;
        position: relative;
        display: inline-block;
        cursor: pointer;
        background: #00b7ee;
        padding: 0;
        color: #fff;
        text-align: center;
        border-radius: 3px;
        overflow: hidden;
    }
    .webuploader-pick-hover {
        background: #00a2d4;
    }
    .webuploader-pick-disable {
        opacity: 0.6;
        pointer-events:none;
    }
</style>



// WEBPACK FOOTER //
// src/components/upLoad/uploadBtn.vue